import { Injectable } from '@angular/core';
import * as eventsMapping from '@assets/json/icon-mapping.json';

@Injectable()
export class MappingService {
  private mappings;
  private indicatorsMapping = [{ key: 'gsmLevel', title: 'title', icon: 'i_1.png', order: 1 }];
  private geocoder;

  constructor() {
    this.geocoder = new google.maps.Geocoder();
  }

  getEventMapping(eventId: string) {
    if (!this.mappings) {
      this.mappings = eventsMapping;
    }
    const mapping = this.mappings.find((eventMapping) => {
      return eventMapping.id.toString() === eventId;
    });

    return mapping;
  }

  PlaceInfo(params, cb) {
    const location = new google.maps.LatLng(params.lat, params.lng);
    const geocoder = new google.maps.Geocoder();
    geocoder.geocode({ 'location': location }, function (results, status) {
      if (typeof cb !== 'function') {
        return;
      }
      if (status === google.maps.GeocoderStatus.OK) {
        const place = results[0];
        return cb(place);
      }
      cb();
    });
  }

  getAddress(latitude, longitude, onSuccess, type?, id?) {
    const coordinate = new google.maps.LatLng(latitude, longitude);
    this.geocoder.geocode({ location: coordinate }, (result, status) => {
      onSuccess(result, status);
    });

  }

  getIndicators() {
    return this.indicatorsMapping;
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/services/data/mapping.service.ts